<template> </template>
<script>
import myMixin from "@/mixin/mixin";
export default {
  name: "Meta",
  mixins: [myMixin],
  metaInfo: {
    title: "뉴 장례박사",
    titleTemplate: "",
    htmlAttrs: {
      lang: "ko"
    },
    meta: [
      { charset: "utf-8" },
      { equiv: "X-UA-Compatible", content: "IE=edge" },
      { equiv: "content-language", content: "kr" },
      { equiv: "imagetoolbar", content: "no" },
      { name: "keywords", content: "" },
      { name: "description", content: "" },
      {
        property: "og:site_name",
        content: "lottecastle",
        id: "og-sitename-value"
      },
      { property: "og:type", content: "website", id: "og-type-value" },
      {
        property: "og:url",
        content: "https://new.jrbaksa.com",
        id: "og-url-value"
      },
      { property: "og:title", content: "장례박사", id: "og-title-value" },
      {
        property: "og:description",
        content: "장례박사",
        id: "og-description-value"
      },
      {
        property: "og:image",
        content:
          "https://www.jrbaksa.com/static/landing/common/images/m_logo_kakao.png",
        id: "og-image-value"
      },

      { itemprop: "url", content: "", id: "schema-url-value" },
      { itemprop: "name", content: "", id: "schema-name-value" },
      { itemprop: "description", content: "", id: "schema-discription-value" },

      { name: "keywords", content: "" },
      { name: "description", content: "" },
      { name: "viewport", content: "width=device-width, initial-scale=1.0" },
      { name: "description", content: "gator" },
      { name: "viewport", content: "width=device-width, initial-scale=1" }
    ]
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {
    this.$nextTick(function() {
      this.allLoadingEvent();
    });
  },
  methods: {}
};
</script>
